(function () {
  'use strict';

  function initInstallation(root) {
    if (!root || root.dataset.imInit === 'true') return;
    root.dataset.imInit = 'true';

    var wrap = root.querySelector('[data-im-video-wrap]');
    if (!wrap) return;

    var playBtn = wrap.querySelector('[data-im-play]');
    var template = wrap.querySelector('[data-im-video-template]');
    if (!playBtn || !template) return;

    playBtn.addEventListener('click', function () {
      var fragment = template.content.cloneNode(true);
      wrap.innerHTML = '';
      wrap.appendChild(fragment);

      var video = wrap.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', '');
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            /* Autoplay with sound can be blocked; controls remain visible
               so the shopper can press play manually. */
          });
        }
      }
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-im-section]');
    Array.prototype.forEach.call(sections, initInstallation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-im-section]');
    if (section) initInstallation(section);
  });
})();
